<template>
    <a-card
        hoverable
        :style="{
            width: '100%'
        }"
    >

        <!-- <img
            alt="józsi"
            src="https://szajer.fidesz-eu.hu/wp-content/uploads/2016/11/Fidesz_EUweb_HEADER_kepviselok_SzajerJozsef.png"
            slot="cover"
        /> -->
        <a-card-meta
            :title="title"
            description="Kormánypárti szakszervilista"
        >
            <a-avatar slot="avatar"
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/Fidesz_2015.svg/1200px-Fidesz_2015.svg.png"
            >
            </a-avatar>
        </a-card-meta>
        <template class="ant-card-actions" slot="actions">
            <a-icon type="alert" />
            <a-icon type="edit" 
                v-on:click="editClicked(id)"
            /> 
        </template>

    </a-card>
</template>

<script>
export default {

    props: {
        title: String,
        id: Number,
        editClicked: Function
    },
}
</script>

<style>

</style>
